import styled from "styled-components";

export const GameGalleryContainer = styled.div`
	display: flex;
	overflow: hidden;
	flex-direction: column;
`;
